import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_select = _resolveComponent("b-select")!
  const _component_BFieldHint = _resolveComponent("BFieldHint")!
  const _component_WebhookForm = _resolveComponent("WebhookForm")!

  return (_openBlock(), _createBlock(_component_WebhookForm, {
    id: _ctx.id,
    initial: _ctx.effectiveInitial,
    "visibility-config": _ctx.visibilityConfig,
    onSaved: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('saved')))
  }, {
    parameters: _withCtx(({ getSecret, setSecret }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('datadog.settings')), 1),
        _createVNode(_component_BFieldHint, {
          label: _ctx.$t('datadog.apiKey'),
          hintKey: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_select, {
              "model-value": getSecret('DATADOG_API_KEY'),
              placeholder: _ctx.$t('datadog.selectSecret'),
              "onUpdate:modelValue": val => setSecret('DATADOG_API_KEY', String(val))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secretOptions, (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["label"])
      ])
    ]),
    _: 1
  }, 8, ["id", "initial", "visibility-config"]))
}